import {API_URL,IMG_URL} from './config/config'

export const QUERY_RESULTS = 'CC/QUERY_RESULTS';
export const MODEL_READY = 'CC/MODEL_READY';
export const MODEL_DOWNLOAD_FAILED = 'CC/MODEL_DOWNLOAD_FAILED';
export const STATS_READY = 'CC/STATS_READY';
export const MERGING_READY = 'CC/MERGING_READY';

/**
 * gets the model from the local storage.
 * If local storage is empty, it gets the model from server
 * If the model doesn't exist, returns error
 * @param {string} section 
 */
export function getModel(section){
return new Promise((resolve,reject)=>{
    const data = loadData(section);
    if(data) return resolve({d:data})
    //no data? fetch it
    fetch(`${IMG_URL}/${section}/`).then(res=>res.json()).then(data=>{
        return resolve({d:data})
    }).catch(err=>{
        console.error(`err`, err)
        return resolve(null)
    })
})
}


//loads data from local storage
export function loadData(section) {
    let data = localStorage.getItem('galeria_data_'+section);
    if (!data) return [];
    try {
        data = JSON.parse(data);
    } catch (error) {
        data = []
    }
    return data;
}


//saves data to local storage
export function saveData(section,data) {
    localStorage.setItem('galeria_data_'+section, JSON.stringify(data));
}


//loads data from local storage
export function loadCode() {
    let code = localStorage.getItem('galeria_code');
    if (!code) return '';
    return code;
}


//saves data to local storage
export function saveCode(code) {
    localStorage.setItem('galeria_code', code);
}



export function downloadRawList(section) {
    let code = loadCode()

    return new Promise((resolve, reject) => {
        if (!code) return resolve([])
        fetch(`${API_URL}?key=${code}&section=${section}`).then(res => res.json()).then(oResult => {
      
            let photos = oResult.files.map(row => {
                return {
                    src: path2url(row.p),
                    ts: row.d,
                    width: row.w / row.h,
                    height: 1,
                    tags: path2tags(row.p)
                }
            })
      
            return resolve(photos)
        })

    })
}

export const path2url = (p) => {
    let url = IMG_URL + p.substring(1);
    return url;
}

//split url to  paths, then paths to comma separated tags
//lowercase and trim everything 
const path2tags = (p) => {
    let a = p.split('/')
    let out = [];
    if (!a || a.length > 4) {
        a = a.slice(2, -1)
        if (!a.forEach) {
            console.log(`p`, p)
            debugger;
        }
        a.forEach(chunk => {
            let aa = chunk.split(',');
            aa.forEach(tag => {
                out.push(tag.trim().toLowerCase())
            })
        })
    } else {
        console.log(`bad path`, p)
    }

    return out;
}

export function downloadJson(section,oExport) {
    // const code=loadCode()
    let buf = JSON.stringify(oExport);
    const link = document.createElement('a');
    const filename = `list_${section}.json`;
    const url = window.URL.createObjectURL(
        new Blob([buf]),
    );

    // link.setAttribute('href', encodeURI(csv));
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.click();
}



export const mergeRawImages = (raw, images) => {

}
